import { Router } from '@angular/router';
import { Component, OnDestroy } from '@angular/core';
import { UserService, PermissionService } from '../services';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'create-topic-link',
    template: `
        <button *ngIf="currentUser() && canCreateStreams && !userIsCatalogManager"
                mat-button 
                [routerLink]="['/topics', 'create']" 
                class="navButton"
                matTooltip="Create a new topic.">
            <span fxHide.xs>Create Topic</span>
            <div fxHide.gt-xs fxLayout="row"><mat-icon style="padding-top: 5px;">add</mat-icon> <div style="font-size: 18px;">Topic</div></div>
        </button>
    `
})
export class CreateTopicLinkComponent implements OnDestroy {
    private cleanupTime = new Subject<void>();
    canCreateStreams: boolean;
    userIsCatalogManager: boolean;

    constructor(router: Router, permissionService: PermissionService, private userService: UserService) {
        router.events.pipe(takeUntil(this.cleanupTime)).subscribe(() => this.canCreateStreams = permissionService.currentUserCanCreateStream());
        this.userIsCatalogManager = this.userService.isCurrentUserCatalogManager();
    }

    currentUser = () => this.userService.getCurrentUser();

    ngOnDestroy(): void {
        this.cleanupTime.next();
        this.cleanupTime.complete();
    }
}
